export default function () {

  window.debug('debug: init storage');

  function dbConnect() {
    return indexedDB.open('vadodb', 2);
    window.debug('debug: connecting to db');
  }

  function deleteRow(key) {
    let con = dbConnect();

    con.onsuccess = function (event) {
      const db = event.target.result;

      const transaction = db.transaction(['contacts'], 'readwrite')
        .objectStore('contacts')
        .delete(key);

      transaction.onsuccess = (event) => {
        window.debug('debug:' + key + ' deleted.');
        window.getCount();
      };
    }
  }

  window.getCount = function () {
    const con = dbConnect();

    con.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('contacts')) {
        db.createObjectStore('contacts', { autoIncrement: true });
      }
    };

    con.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction('contacts', 'readonly').objectStore('contacts');
      const countRequest = transaction.count();

      countRequest.onsuccess = function (event) {
        document.getElementById('data-counter').textContent = countRequest.result;

        return countRequest.result;
      }
    }
  }

  window.storeDataLocally = function (data) {
    let con = dbConnect();

    con.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('contacts')) {
        db.createObjectStore('contacts', { autoIncrement: true });
      }
    };

    con.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction('contacts', 'readwrite');
      const store = transaction.objectStore('contacts');
      store.add(data);
      window.debug('debug: inserted');
      window.debug(data);
    };
  }

  window.uploadData = function () {
    let con = dbConnect();

    con.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('contacts')) {
        db.createObjectStore('contacts', { autoIncrement: true });
      }
    };

    con.onerror = (event) => {
      alert(`Database error: ${event.target.errorCode}`);
    };

    con.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction(['contacts']);
      const store = transaction.objectStore('contacts');

      window.debug('debug: looping data');
      store.openCursor().onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          window.debug('debug: uploading ' + cursor.key);

          sendDataToServer(cursor.key,cursor.value);

          cursor.continue();
        } else {
          window.debug('debug: end of data');
        }
      };
    };
  }

  async function sendDataToServer(key, value) {
    fetch('/data/store/', {
      method: 'POST',
      body: JSON.stringify(value),
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
      if (response.ok) {
        window.debug('debug: send success');

        deleteRow(key);
      } else {
        window.debug('debug: send fail');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

}
